var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { PermissionsCheck } from '../Components/Auth/PermissionsCheck';
import { iconLight } from '../Styles/Colours';
import { Button, ButtonMode } from '../Components/Button';
import { EditIcon, TrashCanIcon } from '../Components/Icons';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { DeleteMedicationDialog } from '../MedicationSummary/DeleteMedicationDialog';
import styles from './MedicationActions.module.css';
export function MedicationActions(props) {
    var _a = __read(useState(false), 2), showConfirmationDialog = _a[0], setShowDeleteMedicationDialog = _a[1];
    return (React.createElement("div", { className: styles.actions },
        React.createElement(PermissionsCheck, { key: 'edit', permission: MedicationsPermissions.AccessCode },
            React.createElement(Button, { iconOnly: true, tooltip: 'Edit', mode: ButtonMode.text, noShadowOnHover: true, testId: "navigation-edit-" + props.row.id, subtleShadeOnHover: true, variant: props.buttonVariantColour, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onView(props.row.id);
                } },
                React.createElement(EditIcon, { color: iconLight, size: '24' }))),
        React.createElement(PermissionsCheck, { key: 'delete', permission: MedicationsPermissions.AccessCode },
            React.createElement(Button, { iconOnly: true, tooltip: 'Delete', mode: ButtonMode.text, noShadowOnHover: true, testId: "navigation-delete", subtleShadeOnHover: true, variant: props.buttonVariantColour, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowDeleteMedicationDialog(true);
                } },
                React.createElement(TrashCanIcon, { color: iconLight, size: '24' }))),
        showConfirmationDialog && (React.createElement(DeleteMedicationDialog, { medicationName: props.row.name, medicationId: props.row.id, onDelete: props.onDelete, setShowDeleteMedicationDialog: function () { return setShowDeleteMedicationDialog(false); } }))));
}
